<template>
  <div class="bg-gray-100 min-h-screen py-4">
    <div class="container mx-auto px-4">
      <div class="tabs mb-6">
        <ul class="flex border-b border-gray-200">
          <li
            v-for="(program, index) in programs"
            :key="program.programId"
            @click="selectedTab = index"
            :class="['cursor-pointer py-2 px-4', selectedTab === index ? 'border-b-2 border-blue-500 text-blue-500' : 'text-gray-500']"
          >
            {{ program.programName }}
          </li>
        </ul>
      </div>
      <div class="tab-content">
        <div v-for="(program, index) in programs" :key="program.programId" v-show="selectedTab === index">
          <div v-for="(date, idx) in program.dates" :key="idx" class="mb-10">
            <div class="bg-white p-6 rounded-lg shadow-md mb-6">
              <div class="text-center mb-8">
                <router-link :to="`${dailyActivitiesFrontendRoute}?cd=${date.date}`">
                  <h2 class="text-2xl font-semibold">{{ formatDate(date.date) }}</h2>
                </router-link>
              </div>
              <div class="activity-section mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <div v-for="(activity, index) in date.activities" :key="index" class="bg-gray-50 p-4 rounded-lg shadow-sm">
                  <div class="flex items-center text-sm mb-2">
                    <span class="bg-blue-500 text-white px-2 py-1 rounded mr-2">{{ activity.hour }}</span>
                  </div>
                  <div>
                    <span class="font-bold">{{$t('Service')}}: </span>
                    <a-tag
                      v-if="!isEmpty(activity.service)" @click="goToEditRoute(activity.service.id, 'servicesEditRoute', date.date)"
                      class="cursor-pointer"
                      color="green"
                    >
                      <a-badge>
                        <div class="mt-1"> {{activity.service.name}} </div>
                      </a-badge>
                    </a-tag>
                  </div>

                  <p class="text-sm text-gray-600 mb-2">{{ activity.description }}</p>
                  <div class="flex items-center mt-2">
                    <div>
                      <div class="mt-2">
                        <span class="font-bold">{{$t('Leader')}}: </span>
                        <a-tag
                          v-if="!isEmpty(activity.leader)" @click="goToEditRoute(activity.leader.id, 'leadersEditRoute', date.date)"
                          class="cursor-pointer"
                          color="blue"
                        >
                          <a-badge>
                            <div class="mt-1"> {{activity.leader.name}} </div>
                          </a-badge>
                        </a-tag>
                      </div>

                      <div class="mt-2">
                        <span class="font-bold">{{$t('Hotel')}}: </span>
                        <a-tag
                          v-if="!isEmpty(activity.hotel)" @click="goToEditRoute(activity.hotel.id, 'hotelsEditRoute', date.date)"
                          class="cursor-pointer"
                          color="pink"
                        >
                          <a-badge>
                            <div class="mt-1"> {{activity.hotel.name}} </div>
                          </a-badge>
                        </a-tag>
                      </div>

                    </div>
                  </div>
                  <div class="mt-4">
                    <h5 class="font-semibold">{{$t('Passengers')}}: </h5>
                    <ul class="list-disc list-inside">
                      <li v-for="passenger in activity.passengers" :key="passenger.id">{{ passenger.name }}</li>
                    </ul>
                  </div>
                  <div class="mt-4">
                    <h5 class="font-semibold">{{$t('News')}}: </h5>
                    <p class="text-sm text-gray-500">{{ activity.news }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    dailyActivitiesFrontendRoute: {
      type: String
    },
    programDetailFrontendRoute: {
      type: String
    },
    servicesEditRoute: {
      type: String
    },
    hotelsEditRoute: {
      type: String
    },
    leadersEditRoute: {
      type: String
    },
    vehiclesEditRoute: {
      type: String
    },
    programs: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selectedTab: 0
    }
  },
  methods: {
    isEmpty (value) {
      if (value && typeof value === 'object') {
        return Object.keys(value).length === 0
      }
      return !value || (typeof value === 'string' && value.trim().length === 0)
    },
    goToEditRoute (id, serviceRoute, date) {
      this.$router.push({ path: `${this[serviceRoute]}${id}`, query: { cd: date } }).catch(e => {})
    },
    formatTime (datetime) {
      return moment(datetime).format('HH:mm')
    },
    formatDate (datetime) {
      return moment(datetime).format('D [de] MMMM [de] YYYY')
    }
  }
}
</script>

<style scoped>
</style>
